import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  Row,
  Col,
  Form,
  Select,
  Input,
  Button,
  AutoComplete,
  Collapse,
  Tooltip,
  Checkbox,
  Layout,
  Modal,
  Spin,
} from "antd";
import { FileDoneOutlined } from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../styles/Main.scss";
import verifybtn from "../image/verifybtn.png";
import InputField from "../common/htmlComponents/InputField";
import EmailField from "../common/htmlComponents/EmailField";
import { ReactComponent as Vector } from "../image/Vector.svg";
import { ReactComponent as AddressLine } from "../image/AddressLine.svg";
import { ReactComponent as Email } from "../image/Email.svg";
import { ReactComponent as Name } from "../image/Name.svg";
import { ReactComponent as IdcardOutlined } from "../image/IdcardOutlined.svg";
import { ReactComponent as ZipCode } from "../image/ZipCode.svg";
import { ReactComponent as FileAlt } from "../image/FileAlt.svg";
import newLogo from "../image/PROCEM3.svg";
import { authUserData } from "../utils/Helper";
import { getRequest, patchRequest, postRequest } from "../axios";
import ButtonField from "../common/htmlComponents/ButtonField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../utils/Notifications";
import { debounce } from "lodash";
// import KeyPersonVendor from "../feature/vendor/KeyPersonVendor";
// import PaymentVendor from "../feature/vendor/PaymentVendor";
// import VendorDocumentField from "../feature/vendor/VendorDocumentField";
// import CommunicationMatrixVendor from "../feature/vendor/CommunicationMatrixVendor";
// import PaymentPersonReleasedField from "../feature/vendor/PaymentPersonReleasedField";
import StepInquiryValueVendor from "../authentication/steps/StepInquiryValueVendor";
// import SupplierBillingDetails from "../feature/vendor/SupplierBillingDetails";
import VerifyOtpModal from "../authentication/VerifyOtpModel";
import PhoneOtpVerify from "../authentication/PhoneOtpVerify";
// import BankDetailsForWithoutStep from "BankDetailsForWithoutStep";

const { Option } = Select;

const Vendorlogin = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const VendorId = id ? id : null;
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;
  const formRef = useRef();
  const initialDocument = { vendor_company: null, document_name: null };
  const { Panel } = Collapse;
  const [verificationResultPancard, setVerificationResultPancard] =
    useState(null);
  const [verificationResultContact, setVerificationResultContact] =
    useState(null);
  const [verificationResultEmail, setVerificationResultEmail] = useState(null);
  const [verifyEmailButtonView, setVerifyEmailButtonView] = useState(true);
  const [verificationResultAdhaar, setVerificationResultAadhaar] =
    useState(null);
  const [btnLoadingAdhaar, setBtnLoadingAdhaar] = useState(false);
  const [verifyAdhaar, setVerifyAdhaar] = useState(false);
  const [verifyPhoneButtonView, setVerifyPhoneButtonView] = useState(true);
  const [OTP, setOTP] = useState(null);
  const [OTPPhone, setOTPPhone] = useState(null);
  const [paymentTermsId, setPaymentTermsId] = useState(null);
  const initialState = {
    vendor_registered_name: null,
    person_name: null,
    designation: null,
    website: null,
    no_of_employees: null,
    company_pan: null,
    gst_no: null,
    email: null,
    phone: null,
    lut_number: null,
    msme: false,
    msme_number: null,
    vendor_trade_name: null,
    phone_verified: false,
    email_verified: false,
    gst_no_verified: false,
    udyam_aadhaar_no_verified: false,
    registered_business_address_building: null,
    registered_business_address_area: null,
    registered_business_address_landmark: null,
    registered_business_address_state: null,
    registered_business_address_city: null,
    registered_business_address_pincode: null,
    trading_address_building: null,
    trading_address_area: null,
    trading_address_landmark: null,
    trading_address_state: null,
    trading_address_city: null,
    trading_address_pincode: null,
    same_as_registered_business_address: false,

    vendor_inquiry_value: [
      {
        company: CompanyId,
        category_tree: 1,
        company_material_type: [],
        minimum_inquiry_value: null,
        maximum_inquiry_value: null,
        city: [],
      },
    ],
    vendor_company_code: {
      company: CompanyId,
      vendor_code_by_company: null,
    },
  };

  const [state, setState] = useState(initialState);
  const [pincodeListBillingRegistered, setPincodeListBillingRegistered] =
    useState([]);
  const [searchValueBilling, setSearchValueBilling] = useState("");
  const [pincodeListShipping, setPincodeListShipping] = useState([]);
  const [searchValueShipping, setSearchValueShipping] = useState("");
  const [documentState, setDocumentState] = useState(initialDocument);
  const [isGstNoReadOnly, setIsGstNoReadOnly] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoadingPhone, setBtnLoadingPhone] = useState(false);
  const [btnLoadingEmail, setBtnLoadingEmail] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const [pincodeList, setPincodeList] = useState([]);
  const [categoryTree, setCategoryTree] = useState([]);
  const [categoryTreeCity, setCategoryTreeCity] = useState([]);
  const [uploadFile, setUploadFile] = useState("");
  const [fileLink, setFileLink] = useState(null);
  const [fileNameOne, setFileNameOne] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [addedVendorId, setAddedVendorId] = useState(null);
  const [gstVendorId, setgstVendorId] = useState(null);
  const [vendorDocumentId, setVendorDocumentId] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [postGeneratedVendorId, setPostGeneratedVendorId] = useState(null);
  const [keyPersonId, setKeyPersonId] = useState(null);
  const [paymentReleasedId, setPaymentReleasedId] = useState(null);
  const [communicationMatrixId, setCommunicationMatrixId] = useState(null);
  const [bankDetailId, setBankDetailId] = useState(null);
  const [supplierBillingId, SetSupplierBillingId] = useState(null);
  const [bankdetailsIDs, SetBankDetailsIDs] = useState(null);
  const [materialType, setMaterialType] = useState([]);
  const [gstValue, setGstValue] = useState(null);
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [btnLoadingVerifyGst, setBtnLoadingVerifyGst] = useState(false);
  const [verifyGstDisable, setVerifyDisable] = useState(true);
  const [verifyGstButtonView, setVerifyGstButtonView] = useState(true);
  const [verifyAdhaarButtonView, setVerifyAdhaarButtonView] = useState(true);

  const url = state.msme_document;
  const [showKeyPersonCollapse, setShowKeyPersonCollapse] = useState(false);
  const [showVendorCommunicationCollapse, setShowVendorCommunicationCollapse] =
    useState(false);
  const [showBankDetailsCollapse, setShowBankDetailsCollapse] = useState(false);
  const [showVendorBillingDetails, setShowVendorBillingDetails] =
    useState(false);
  const [showAssignSiteCollapse, setShowAssignSiteCollapse] = useState(false);
  const [showPaymentCollapse, setShowPaymentCollapse] = useState(false);
  const [showPaymentPersonReleasedField, setShowPaymentPersonReleasedField] =
    useState(false);
  const [identifyProfileUrl, setIdentifyProfileUrl] = useState(null);
  const [uploadFileProfilePic, setUploadFileProfilePic] = useState("");
  const [fileList, setFileList] = useState([]);
  const [disabledOptions, setDisabledOptions] = useState([]);
  const [venId, setVenId] = useState(null);
  useState([]);
  const [showbank, setShowbank] = useState(false);

  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);
  const [minutesPhone, setMinutesPhone] = useState(1);
  const [secondsPhone, setSecondsPhone] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenPhone, setIsModalOpenPhone] = useState(false);
  const [existingVendor, setExistingVendor] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setOTP(null);
    setSeconds(30);
    setMinutes(1);
    setBtnLoadingEmail(false);
  };
  const showModalPhone = () => {
    setIsModalOpenPhone(true);
  };
  const handleOkPhone = () => {
    setIsModalOpenPhone(false);
  };
  const handleCancelPhone = () => {
    setIsModalOpenPhone(false);
    setOTPPhone(null);
    setSecondsPhone(30);
    setMinutesPhone(1);
    setBtnLoadingPhone(false);
  };

  const handleAdhaarNumberVerify = async () => {
    setVerifyAdhaar(true);
    setVerifyAdhaarButtonView(true);
    try {
      const adhaarNumber = state?.udyam_aadhaar_no;
      if (adhaarNumber) {
        setBtnLoadingAdhaar(true);
        const response = await getRequest(
          `doc-verification/udhyam/?udhyam_no=${adhaarNumber}`
        );
        if (response.data.success === true) {
          setState((prevState) => ({
            ...prevState,
            udyam_aadhaar_no_verified: true,
          }));
          SuccessNotificationMsg("Udyam Number verified successfully");
          setVerificationResultAadhaar("success");
          setBtnLoadingAdhaar(false);
          setVerifyAdhaarButtonView(false);
        } else {
          setBtnLoadingAdhaar(false);
          setVerifyAdhaarButtonView(true);
        }
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying number"));
      setBtnLoadingAdhaar(false);
      setVerifyAdhaarButtonView(true);
    }
  };
  const handleGstNumberVerify = async () => {
    setVerifyDisable(true);
    setVerifyGstButtonView(true);
    try {
      setBtnLoadingVerifyGst(true);
      const gst = state?.gst_no;
      const apiResponse = await getRequest(
        `doc-verification/gst/?gst_no=${gst}`
      );
      if (apiResponse.data.success === true) {
        setState((prevState) => ({
          ...prevState,
          gst_no_verified: true,
        }));
        SuccessNotificationMsg("GST verified successfully");
        setVerificationStatus("success");
        setBtnLoadingVerifyGst(false);
        setVerifyGstButtonView(false);

        if (apiResponse.data.success === true) {
          const {
            company,
            legal_name,
            building_name,
            door_name,
            street,
            city,
            pincode,
            state,
            company_payment_terms,
            keypersons,
            bankdetails,
            assgin_city,
            inquiry_value,
            vendor_company_code_data,
            ...filteredResponse
          } = apiResponse.data.data;

          formRef.current.setFieldsValue({
            vendor_registered_name: legal_name,
            registered_business_address_building: door_name,
            registered_business_address_area: street,
            registered_business_address_pincode: pincode,
          });

          setState((prevState) => ({
            ...prevState,
            vendor_registered_name: legal_name,
            registered_business_address_building: door_name,
            registered_business_address_area: street,
          }));

          handlePincodeBillingChange(pincode);
          searchINBillingRegistered(pincode);
        }
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying GST number"));
      setVerifyDisable(false);
      setBtnLoadingVerifyGst(false);
      setVerifyGstButtonView(true);
    }
  };

  const [sameAsRegisteredBusinessAddress, setSameAsRegisteredBusinessAddress] =
    useState(false);

  let filename = "";
  let filenameone = "";
  try {
    if (fileLink) {
      filename = url.split("/").pop();
    }
  } catch (e) {
    filename = "";
  }
  const onChange = (key) => {
    console.log(key);
  };

  useEffect(() => {
    const getVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          `vendor/${VendorId}/?company_id=${CompanyId}`
        );

        setVenId(apiResponse.data.data.id);
        if (apiResponse.data.success) {
          const {
            unique_code,
            id,
            company_payment_terms,
            keypersons,
            bankdetails,
            suppliers_billing_details,
            assign_city,
            inquiry_value,
            vendor_company_code,
            ...filteredResponse
          } = apiResponse.data.data;
          if (
            apiResponse.data.data.trading_address_state !== null &&
            apiResponse.data.data.trading_address_state !== undefined &&
            apiResponse.data.data.trading_address_state !== ""
          ) {
            //getCityByStateTrading(apiResponse.data.data.trading_address_state);
          }
          if (
            apiResponse.data.data.registered_business_address_state !== null &&
            apiResponse.data.data.registered_business_address_state !==
              undefined &&
            apiResponse.data.data.registered_business_address_state !== ""
          ) {
            // getCityByStateForShipping(
            //   apiResponse.data.data.registered_business_address_state
            // );
          }
          if (apiResponse.data.data.keypersons.length > 0) {
            const keyPersonId =
              apiResponse.data.data.keypersons[0].id !== null
                ? apiResponse.data.data.keypersons[0].id
                : null;
            setKeyPersonId(keyPersonId);
          } else {
            setKeyPersonId(null);
          }
          const inquiryValueFromApi = apiResponse.data.data.inquiry_value;
          const categoryTreeMaterials =
            inquiryValueFromApi && inquiryValueFromApi.length > 0
              ? inquiryValueFromApi[0].category_tree_materials
              : [];

          setState({
            ...filteredResponse,
            vendor_inquiry_value: categoryTreeMaterials.map((inquiry) => {
              const {
                vendor,
                vendor_name,
                category_tree_name,
                category_tree,
                company_name,
                company,
                city,
                city_name,
                company_material_type,
                ...rest
              } = inquiry;

              return {
                company:
                  inquiryValueFromApi && inquiryValueFromApi.length > 0
                    ? inquiryValueFromApi[0].company
                    : CompanyId,
                category_tree: category_tree,
                company_material_type: company_material_type.map(
                  (material) => material.id
                ),
                city: city.map((material) => material.id),
                ...rest,
              };
            }),
            vendor_company_code: {
              id: apiResponse.data.data.vendor_company_code[0].id,
              company: CompanyId,
              vendor_code_by_company:
                apiResponse.data.data.vendor_company_code[0]
                  .vendor_code_by_company,
            },
          });

          const newItem = categoryTreeMaterials.map((item) => {
            return item.category_tree;
          });
          setDisabledOptions(newItem);
          setShowKeyPersonCollapse(true);
          setShowVendorCommunicationCollapse(true);
          setShowbank(true);
          if (apiResponse?.data?.data?.email_verified === true) {
            setVerificationResultEmail("success");
            setVerifyEmailButtonView(false);
          } else {
            setVerificationResultEmail(null);
            setVerifyEmailButtonView(true);
          }

          if (apiResponse?.data?.data?.phone_verified === true) {
            setVerificationResultContact("success");
            setVerifyPhoneButtonView(false);
          } else {
            setVerificationResultContact(null);
            setVerifyPhoneButtonView(true);
          }

          if (apiResponse?.data?.data?.gst_no_verified === true) {
            setVerificationStatus("success");
            setVerifyGstButtonView(false);
          } else {
            setVerificationStatus(null);
            setVerifyGstButtonView(true);
          }

          if (apiResponse?.data?.data?.udyam_aadhaar_no_verified === true) {
            setVerificationResultAadhaar("success");
            setVerifyAdhaarButtonView(false);
          } else {
            setVerificationResultAadhaar(null);
            setVerifyAdhaarButtonView(true);
          }

          setPostGeneratedVendorId(apiResponse.data.data.id);
          setFileLink(apiResponse.data.data.msme_document);
          if (apiResponse.data.data.keypersons.length > 0) {
            const keyPersonId =
              apiResponse.data.data.keypersons[0].id !== null
                ? apiResponse.data.data.keypersons[0].id
                : null;

            setKeyPersonId(keyPersonId);
            setShowVendorBillingDetails(keyPersonId !== null);
          } else {
            setKeyPersonId(null);
            setShowVendorBillingDetails(false);
          }
          if (apiResponse.data.data.payment_released.length > 0) {
            const paymentReleasedId =
              apiResponse.data.data.payment_released[0].id !== null
                ? apiResponse.data.data.payment_released[0].id
                : null;
            setPaymentReleasedId(paymentReleasedId);
          } else {
            setPaymentReleasedId(null);
          }

          const supplierBillingId =
            apiResponse.data.data.suppliers_billing_details[0].id !== null
              ? apiResponse.data.data.suppliers_billing_details[0].id
              : null;
          SetSupplierBillingId(supplierBillingId);
          setShowBankDetailsCollapse(supplierBillingId !== null);

          const bankdetailsIDs =
            apiResponse.data.data.bankdetails[0].id !== null
              ? apiResponse.data.data.bankdetails[0].id
              : null;
          SetBankDetailsIDs(bankdetailsIDs);
          setShowPaymentCollapse(bankdetailsIDs !== null);

          const communicationMatrixId =
            apiResponse.data.data.vendor_communication_matrix_data[0].id !==
            null
              ? apiResponse.data.data.vendor_communication_matrix_data[0].id
              : null;
          setCommunicationMatrixId(communicationMatrixId);
          const paymentTermsId =
            apiResponse.data.data.company_payment_terms[0].id !== null
              ? apiResponse.data.data.company_payment_terms[0].id
              : null;
          setPaymentTermsId(paymentTermsId);
          setShowPaymentPersonReleasedField(paymentTermsId !== null);
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            lut_number: apiResponse.data.data.lut_number,
            vendor_trade_name: apiResponse.data.data.vendor_trade_name,
            vendor_registered_name:
              apiResponse.data.data.vendor_registered_name,
            registered_business_address_building:
              apiResponse?.data?.data?.registered_business_address_building,
            registered_business_address_area:
              apiResponse?.data?.data?.registered_business_address_area,
            registered_business_address_landmark:
              apiResponse?.data?.data?.registered_business_address_landmark,
            registered_business_address_state:
              apiResponse?.data?.data?.registered_business_address_state,
            registered_business_address_city:
              apiResponse?.data?.data?.registered_business_address_city,
            registered_business_address_pincode:
              apiResponse?.data?.data
                ?.registered_business_address_pincode_number,
            trading_address_building:
              apiResponse?.data?.data?.trading_address_building,
            trading_address_area: apiResponse?.data?.data?.trading_address_area,
            trading_address_landmark:
              apiResponse?.data?.data?.trading_address_landmark,
            trading_address_state:
              apiResponse?.data?.data?.trading_address_state,
            trading_address_city: apiResponse?.data?.data?.trading_address_city,
            trading_address_pincode:
              apiResponse?.data?.data?.trading_address_pincode_number,

            pincode: apiResponse.data.data.pincode_name,
            phone: String(apiResponse.data.data.phone),
            msme: apiResponse.data.data.msme,
            city: apiResponse.data.data.city_name,
            vendor_inquiry_value: categoryTreeMaterials.map((inquiry) => {
              const {
                vendor,
                vendor_name,
                category_tree_name,
                city_name,
                city,
                company_material_type_name,
                ...rest
              } = inquiry;
              return {
                city_name,
                city,
                ...rest,
              };
            }),
            vendor_code_by_company:
              apiResponse.data.data.vendor_company_code[0]
                .vendor_code_by_company,
          });
          if (
            apiResponse.data.data?.registered_business_address_building ===
              apiResponse.data.data?.trading_address_building &&
            apiResponse.data.data?.registered_business_address_area ===
              apiResponse.data.data?.trading_address_area &&
            apiResponse.data.data?.registered_business_address_landmark ===
              apiResponse.data.data?.trading_address_landmark &&
            apiResponse.data.data?.registered_business_address_state ===
              apiResponse.data.data?.trading_address_state &&
            apiResponse.data.data?.registered_business_address_city ===
              apiResponse.data.data?.trading_address_city &&
            apiResponse.data.data?.registered_business_address_pincode ===
              apiResponse.data.data?.trading_address_pincode
          ) {
            setSameAsRegisteredBusinessAddress(true);
          }
          const url = apiResponse.data.data.vendor_logo;
          setIdentifyProfileUrl(apiResponse.data.data.vendor_logo);
          if (url !== null) {
            setFileList([
              {
                url: url,
              },
            ]);
          }
          setSelectedOption(apiResponse.data.data.msme);
          const modifiedInquiry = categoryTreeMaterials.map((inquiryDetail) => {
            const { id, vendor, vendor_name, ...rest } = inquiryDetail;
            return rest;
          });
          setWeightSizeInquiryFieldValue(modifiedInquiry);

          const modifiedInquiryCity = apiResponse.data.data.assign_city.map(
            (inquiryDetail) => {
              const { id, vendor, vendor_name, ...rest } = inquiryDetail;
              return rest;
            }
          );
          setWeightSizeInquiryFieldValueCity(modifiedInquiryCity);

          const modifiedCommunicationMatrix =
            apiResponse.data.data.vendor_communication_matrix_datavendor_communication_matrix_data.map(
              (communicationMatrix) => {
                const { id, vendor, vendor_name, ...rest } =
                  communicationMatrix;
                return rest;
              }
            );
          setWeightSizeInquiryFieldValueCommunicationMatrix(
            modifiedCommunicationMatrix
          );

          const modifiedInquirySuppliers =
            apiResponse.data.data.suppliers_billing_details.map(
              (inquiryDetail) => {
                const { id, vendor, vendor_name, ...rest } = inquiryDetail;
                return rest;
              }
            );
          setWeightSizeInquiryFieldValueSuppliers(modifiedInquirySuppliers);
          setShowKeyPersonCollapse(true);
          if (VendorId !== null) {
            setIsGstNoReadOnly(true);
          } else {
            ErrorNotificationMsg(t("err_getSubscription"));
          }
          setFormSubmitted(true);
        } else {
          ErrorNotificationMsg(t("error_in_list_delivery_address"));
          setSameAsRegisteredBusinessAddress(false);
        }

        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (VendorId !== null) {
      getVendorOnboarding();
    }
    // getCategoryTree();
    // getMaterialTypeByCategory();
  }, [VendorId, CompanyId, t]);

  const [pincodeListBilling, setPincodeListBilling] = useState([]);
  const searchINBilling = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListBilling(apiResponse.data.results.data);
    }
  };
  const onSearchBilling = async (value) => {
    setSearchValueBilling(value);
    value.length >= 4
      ? searchINBilling(!value ? null : value)
      : setPincodeListBilling([]);
  };

  useEffect(() => {
    const getVendorDocument = async () => {
      setapiloading(true);
      try {
        let filenameone1;
        const apiResponse = await getRequest(
          "vendor-document/" + vendorDocumentId
        );

        if (apiResponse.data.success) {
          setDocumentState({
            ...apiResponse.data.data,
          });
          try {
            filenameone1 = apiResponse.data.data.document_url.split("/").pop();
            setFileNameOne(filenameone1);
          } catch (e) {
            filenameone1 = "";
            setFileNameOne(null);
          }
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
          });
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (vendorDocumentId !== null) {
      getVendorDocument();
    }
  }, [vendorDocumentId, t]);
  const getCategoryTree = async (data) => {
    await getRequest("category-tree/?no_pagination=True", data).then(
      (response) => {
        setCategoryTree(response.data.data);
        setCategoryTreeCity(response.data.data);
      }
    );
  };
  const getMaterialTypeByCategory = async (categoryId) => {
    try {
      const materialTypeResponse = await getRequest(
        `material-type/?category_tree_id=${1}`
      );

      setMaterialType(materialTypeResponse.data.results.data);
    } catch (error) {
      console.error("Error fetching material types:", error);
    }
  };
  const phoneValidLength = state.phone;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error(t("please_enter_valid_phone")));
    }

    return Promise.resolve();
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value !== "" ? value : null });
  };
  const handleInputChangeEmail = (e) => {
    let { name, value } = e.target;
    setVerifyEmailButtonView(true);
    setVerificationResultEmail("");
    setState((prevState) => ({
      ...prevState,
      email: value !== "" ? value : null,
      email_verified: false,
    }));
  };
  const handleInputAdhaarChange = (e) => {
    let { name, value } = e.target;
    setVerificationResultAadhaar("");
    setVerifyAdhaar(true);
    setVerifyAdhaarButtonView(true);
    setState({
      ...state,
      udyam_aadhaar_no: value !== "" ? value : null,
      udyam_aadhaar_no_verified: false,
    });
  };
  const handleInputChangePancard = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value !== "" ? value : null });
    setVerificationResultPancard("");
  };
  const handleInputChangeVendorCode = (e) => {
    let { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      vendor_company_code: {
        ...prevState.vendor_company_code,
        vendor_code_by_company: value !== "" ? value : null,
      },
    }));
  };

  let flag = false;

  const debouncedFetchData = useCallback(
    debounce(async (value) => {
      try {
        if (value !== "" && VendorId === null) {
          setapiloading(true);
          setGstValue(value);
          const apiResponse = await getRequest(
            `get-vendor-by-gst/?gst_no=${value}`
          );
          let response = apiResponse?.data?.results?.data[0];
          if (response?.company_payment_terms[0]?.company === CompanyId) {
            setExistingVendor(true);
          } else {
            setExistingVendor(false);
          }

          if (!flag) {
            if (apiResponse.data.results.data.length > 0) {
              const {
                pincode_name,
                unique_code,
                id,
                company_payment_terms,
                keypersons,
                bankdetails,
                assgin_city,
                inquiry_value,
                vendor_company_code_data,
                ...filteredResponse
              } = apiResponse.data.results.data[0];

              setapiloading(false);
              setgstVendorId(apiResponse.data.results.data[0].id);
              setPostGeneratedVendorId(null);

              const inquiryValueFromApi =
                apiResponse.data.results.data[0].inquiry_value;
              const categoryTreeMaterials =
                inquiryValueFromApi && inquiryValueFromApi.length > 0
                  ? inquiryValueFromApi[0].category_tree_materials
                  : [];
              setState({
                ...filteredResponse,
                vendor_inquiry_value: categoryTreeMaterials.map(
                  (inquiryDetail) => {
                    const {
                      id,
                      vendor,
                      vendor_name,
                      category_tree_name,
                      company_name,
                      company,
                      category_tree,
                      city_name,
                      city,
                      company_material_type,
                      ...rest
                    } = inquiryDetail;
                    return {
                      ...rest,
                      company:
                        inquiryValueFromApi && inquiryValueFromApi.length > 0
                          ? inquiryValueFromApi[0].company
                          : CompanyId,
                      category_tree: category_tree,
                      company_material_type: company_material_type.map(
                        (material) => material.id
                      ),
                      city: city.map((c) => c.id),
                    };
                  }
                ),
                vendor_company_code: {
                  id: apiResponse.data.results.data[0]
                    .vendor_company_code_data[0].id,
                  company: CompanyId,
                  vendor_code_by_company:
                    apiResponse.data.results.data[0].vendor_company_code_data[0]
                      .vendor_code_by_company,
                },
                assign_city_to_vendor:
                  apiResponse?.data?.results?.data[0]?.assign_city?.map(
                    (inquiryDetail) => {
                      const {
                        id,
                        vendor,
                        vendor_name,
                        city_name,
                        company,
                        company_name,
                        category_tree,
                        material_type_name,
                        ...rest
                      } = inquiryDetail;
                      return {
                        company: CompanyId,
                        category_tree: 1,
                        ...rest,
                      };
                    }
                  ),
              });
              setFileLink(apiResponse.data.results.data[0].msme_document);
              const url = apiResponse.data.results.data[0].vendor_logo;
              setIdentifyProfileUrl(
                apiResponse.data.results.data[0].vendor_logo
              );
              if (url !== null) {
                setFileList([
                  {
                    url: url,
                  },
                ]);
              }
              setShowKeyPersonCollapse(true);
              setShowVendorCommunicationCollapse(true);
              const newItem = categoryTreeMaterials.map((item) => {
                return item.category_tree;
              });
              setDisabledOptions(newItem);
              formRef.current.setFieldsValue({
                ...apiResponse.data.results.data[0],
                pincode: apiResponse.data.results.data[0].pincode_name,
                phone: String(apiResponse.data.results.data[0].phone),
                msme: apiResponse.data.results.data[0].msme,
                registered_business_address_pincode:
                  apiResponse.data.results.data[0]
                    ?.registered_business_address_pincode_number,
                trading_address_pincode:
                  apiResponse.data.results.data[0]
                    .trading_address_pincode_number,
              });
              if (
                apiResponse.data.results.data[0]
                  .registered_business_address_building ===
                  apiResponse.data.results.data[0]?.trading_address_building &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_area ===
                  apiResponse.data.results.data[0]?.trading_address_area &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_landmark ===
                  apiResponse.data.results.data[0]?.trading_address_landmark &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_state ===
                  apiResponse.data.results.data[0]?.trading_address_state &&
                apiResponse.data.results.data[0]
                  ?.registered_business_address_pincode ===
                  apiResponse.data.results.data[0]?.trading_address_pincode
              ) {
                setSameAsRegisteredBusinessAddress(true);
              }
              setSelectedOption(apiResponse.data.results.data[0].msme);

              if (
                apiResponse?.data?.results?.data[0]?.email_verified === true
              ) {
                setVerificationResultEmail("success");
                setVerifyEmailButtonView(false);
              } else {
                setVerificationResultEmail(null);
                setVerifyEmailButtonView(true);
              }

              if (
                apiResponse?.data?.results?.data[0]?.phone_verified === true
              ) {
                setVerificationResultContact("success");
                setVerifyPhoneButtonView(false);
              } else {
                setVerificationResultContact(null);
                setVerifyPhoneButtonView(true);
              }

              if (
                apiResponse?.data?.results?.data[0]
                  ?.udyam_aadhaar_no_verified === true
              ) {
                setVerificationResultAadhaar("success");
                setVerifyAdhaarButtonView(false);
              } else {
                setVerificationResultAadhaar(null);
                setVerifyAdhaarButtonView(true);
              }

              let modifiedInquiryDetails = categoryTreeMaterials.map(
                (inquiry) => {
                  const { id, vendor, category_tree_name, ...rest } = inquiry;
                  return rest;
                }
              );

              let modifiedAssignCityDetails =
                apiResponse.data.results.data[0].assign_city.map((inquiry) => {
                  const { id, vendor, category_tree_name, ...rest } = inquiry;
                  return rest;
                });
              setWeightSizeInquiryFieldValue(modifiedInquiryDetails);
              setWeightSizeAssignCityValue(modifiedAssignCityDetails);
              setShowAssignSiteCollapse(true);
              setShowPaymentCollapse(true);
              setShowKeyPersonCollapse(true);
              setShowVendorCommunicationCollapse(true);
              setShowAssignSiteCollapse(true);
              setShowbank(true);

              setShowVendorBillingDetails(true);
              setShowBankDetailsCollapse(true);
              setShowPaymentCollapse(true);
              setShowPaymentPersonReleasedField(true);
              // setShowBankDetailsWithoutCollapse(false);
            } else {
              setgstVendorId(null);
              setFormSubmitted(false);
              setapiloading(false);
              setShowKeyPersonCollapse(false);
              setShowVendorCommunicationCollapse(false);
              setShowAssignSiteCollapse(false);
              setShowbank(false);

              setShowVendorBillingDetails(false);
              setShowBankDetailsCollapse(false);
              setShowPaymentCollapse(false);
              setShowPaymentPersonReleasedField(false);
              const newState = {
                ...initialState,
                gst_no: value,
              };
              setState({ ...initialState, gst_no: value, phone: "+91" });
              setDisabledOptions([]);
              setFileLink(null);
              const defaultCountryCode = "+91";
              formRef.current.setFieldsValue({
                ...initialState,
                gst_no: value,
                udyam_aadhaar_no: "",
              });
              setSameAsRegisteredBusinessAddress(false);
              state.vendor_inquiry_value.forEach((person, index) => {
                formRef.current.setFieldsValue({
                  [`category_tree${index}`]: "Cement",
                  [`minimum_inquiry_value${index}`]: null,
                  [`minimum_income_measurement${index}`]: "Lakh",
                  [`maximum_inquiry_value${index}`]: null,
                  [`maximum_income_measurement${index}`]: "Lakh",
                });
              });

              formRef.current.setFieldsValue({
                [`company`]: CompanyId,
                [`vendor_code_by_company`]: null,
                [`id`]: null,
              });

              const url = null;
              setIdentifyProfileUrl("");
              setFileList([]);
            }
          } else {
            ErrorNotificationMsg(t("Vendor Already Exist"));
            setapiloading(false);
          }
        }
      } catch (error) {
        setapiloading(false);
        console.error("Error fetching vendor details:", error);
      }
    }, 1200),
    []
  );
  useEffect(() => {
    return () => {
      debouncedFetchData.cancel();
    };
  }, [debouncedFetchData]);
  const gstPattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  const handleGstInputChange = async (e) => {
    let { name, value } = e.target;
    setVerifyGstButtonView(true);

    setState({
      ...state,
      gst_no: value,
      gst_no_verified: false,
    });
    setVerificationStatus(null);
    setVerifyDisable(!gstPattern.test(value));
    // debouncedFetchData(value);
  };

  const handleChange = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const searchIN = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeList(apiResponse.data.results.data);
    }
  };

  const searchINBillingRegistered = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    console.log(
      "API Response (Billing Registered):",
      apiResponse.data.results.data
    ); // Debug log
    if (apiResponse.data.results.success) {
      setPincodeListBillingRegistered(apiResponse.data.results.data);
    }
  };
  const [searchValueBillingRegistered, setSearchValueBillingResgistered] =
    useState("");

  const onSearchBillingResgistered = async (value) => {
    setSearchValueBillingResgistered(value);
    if (value.length >= 1) {
      // Lowered threshold for easier testing
      await searchINBillingRegistered(value);
    } else {
      setPincodeListBillingRegistered([]);
    }
  };
  const [searchValueShippingTrading, setSearchValueShippingTrading] =
    useState("");
  const [pincodeListShippingtrading, setPincodeListShippingTrading] = useState(
    []
  );
  const searchINShippingTrading = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListShippingTrading(apiResponse.data.results.data);
    }
  };
  const onSearchShippingTrading = async (value) => {
    setSearchValueShippingTrading(value);
    value.length >= 4
      ? searchINShippingTrading(!value ? null : value)
      : setPincodeListShippingTrading([]);
  };
  const handlePincodeShippingTradingChange = async (
    trading_address_pincode
  ) => {
    try {
      const response = await getRequest(
        `pincode/?search_pincode_number=${trading_address_pincode}`
      );
      if (response.data.results.data.length > 0) {
        const { state_name, city_name, id } = response.data.results.data[0];
        setState((prevState) => ({
          ...prevState,
          trading_address_state: state_name,
          trading_address_city: city_name,
          trading_address_pincode: id,
        }));
        formRef.current.setFieldsValue({
          trading_address_state: state_name,
          trading_address_city: city_name,
        });
      }
    } catch (error) {
      console.error("Error fetching state and city:", error);
    }
  };

  const onSearch = async (value) => {
    setSearchValue(value);
    value.length >= 4 ? searchIN(!value ? null : value) : setPincodeList([]);
  };

  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);

    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };

  const handleSendOtpEmail = async () => {
    try {
      const payload = {
        email: state?.email ? state.email : "",
      };
      const response = await postRequest(`verified-otp/email-verify/`, payload);
      if (response.data.success) {
        const errorMessage = response?.data?.message || "";

        const emailVerificationRegex = /This [^ ]+ already Verify/;
        if (emailVerificationRegex.test(errorMessage)) {
          setVerifyEmailButtonView(false);

          setState((prevState) => ({
            ...prevState,
            email_verified: true,
          }));
          setVerificationResultEmail("success");
        } else {
          setState((prevState) => ({
            ...prevState,
            email_verified: false,
          }));
          showModal();
          setVerifyEmailButtonView(true);
        }
        SuccessNotificationMsg(response.data.message);
      } else {
        handleCancel();
        setVerificationResultEmail("");
      }
    } catch (error) {
      handleCancel();
      setVerifyEmailButtonView(true);
      setVerificationResultEmail("");
    }
  };
  const handleEmailVerify = async () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid = emailPattern.test(state.email);
    if (isEmailValid) {
      await handleSendOtpEmail();
    } else {
      setVerifyEmailButtonView(true);
      ErrorNotificationMsg("Enter valid email");
    }
  };
  const handlePhoneInputChange = (phone) => {
    setVerifyPhoneButtonView(true);
    setState((prevState) => ({
      ...prevState,
      phone: phone,
      phone_verified: false,
    }));
    setVerificationResultContact("");
  };
  const handleSendOtpPhone = async () => {
    try {
      const payload = {
        phone_number: state?.phone ? state.phone : "",
      };
      const response = await postRequest(
        `verified-otp/phone-number-verify/`,
        payload
      );
      if (response.data.success) {
        const errorMessage = response?.data?.message || "";
        const emailVerificationRegex = /This [^ ]+ already Verify/;

        if (emailVerificationRegex.test(errorMessage)) {
          setVerifyPhoneButtonView(false);

          setState((prevState) => ({
            ...prevState,
            phone_verified: true,
          }));
          setVerificationResultContact("success");
        } else {
          setState((prevState) => ({
            ...prevState,
            phone_verified: false,
          }));
          showModalPhone();
          setVerifyPhoneButtonView(true);
        }
        SuccessNotificationMsg(response.data.message);
      } else {
        setVerificationResultContact("");
        handleCancelPhone();
        setVerifyPhoneButtonView(true);
      }
    } catch (error) {
      setVerifyPhoneButtonView(true);
      handleCancelPhone();
      setVerificationResultContact("");
    }
  };
  const handleContactNumberVerify = async () => {
    const contactNumber = state?.phone;
    const phoneNumberPattern = /^\d{12}$/;

    if (contactNumber && phoneNumberPattern.test(contactNumber)) {
      await handleSendOtpPhone();
    } else {
      ErrorNotificationMsg("Enter valid mobile number");
    }
  };

  const handleSubmit = async () => {
    if (existingVendor === false) {
      const hasEmptyInquiryFields =
        state.vendor_inquiry_value &&
        state.vendor_inquiry_value.some(
          (inquiry) =>
            inquiry.category_tree === null ||
            inquiry.company_material_type.length === 0 ||
            inquiry.minimum_inquiry_value === null ||
            inquiry.maximum_inquiry_value === null ||
            inquiry.city.length === 0
        );

      // if (hasEmptyInquiryFields) {
      //   ErrorNotificationMsg(
      //     "Please fill all Inquiry Value fields before saving."
      //   );
      //   return;
      // }

      // Transform vendor_inquiry_value to required structure
      const companyId = state.vendor_inquiry_value[0]?.company;
      const category_tree_materials = state.vendor_inquiry_value.map((row) => ({
        category_tree: row.category_tree,
        company_material_type: row.company_material_type,
        minimum_inquiry_value: row.minimum_inquiry_value,
        maximum_inquiry_value: row.maximum_inquiry_value,
        city: row.city,
      }));
      const vendor_inquiry_value = [
        {
          company: companyId,
          category_tree_materials,
        },
      ];

      const payload = {
        vendor_registered_name: state.vendor_registered_name
          .toLowerCase()
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        person_name: state.person_name,
        designation: state.designation,
        gst_no: state.gst_no,
        udyam_aadhaar_no: state.udyam_aadhaar_no,
        email: state.email,
        phone: state.phone,
        vendor_trade_name: state.vendor_trade_name,

        email_verified: state.email_verified,
        phone_verified: state.phone_verified,
        gst_no_verified: state.gst_no_verified,
        udyam_aadhaar_no_verified: state.udyam_aadhaar_no_verified,
        registered_business_address_building:
          state.registered_business_address_building,
        registered_business_address_area:
          state.registered_business_address_area,
        registered_business_address_landmark:
          state.registered_business_address_landmark,
        registered_business_address_state:
          state.registered_business_address_state,
        registered_business_address_city:
          state.registered_business_address_city,
        registered_business_address_pincode:
          state.registered_business_address_pincode,
        trading_address_building: state.trading_address_building,
        trading_address_area: state.trading_address_area,
        trading_address_landmark: state.trading_address_landmark,
        trading_address_state: state.trading_address_state,
        trading_address_city: state.trading_address_city,
        trading_address_pincode: state.trading_address_pincode,
      };

      try {
        setBtnLoading(true);
        let apiResponse;
        let customerHeaders = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        const formData = new FormData();

        formData.append("vendor_logo", uploadFileProfilePic);
        formData.append("msme_document", uploadFile);
        formData.append("form_data", JSON.stringify(payload));
        if (VendorId === null && gstVendorId === null) {
          apiResponse = await postRequest(
            "superuser-vendor/",
            formData,
            customerHeaders
          );
        }
        if (VendorId !== null || gstVendorId !== null) {
          const url =
            VendorId !== null
              ? `vendor/${VendorId}/`
              : `vendor/${gstVendorId}/`;

          apiResponse = await patchRequest(url, formData, customerHeaders);
        }
        console.log("apiRddesponse", apiResponse);

        if (apiResponse.data.success === true) {
          SuccessNotificationMsg(apiResponse?.data?.message);
          navigate("/login");
          setIsGstNoReadOnly(true);
          setPostGeneratedVendorId(apiResponse.data.data.id);
          if (apiResponse.data.data.keypersons.length > 0) {
            const keyPersonId =
              apiResponse.data.data.keypersons[0].id !== null
                ? apiResponse.data.data.keypersons[0].id
                : null;

            setKeyPersonId(keyPersonId);
          } else {
            setKeyPersonId(null);
          }

          const bankDetailId =
            apiResponse.data.data.bankdetails[0].id !== null
              ? apiResponse.data.data.bankdetails[0].id
              : null;
          setBankDetailId(bankDetailId);

          const supplierBillingId =
            apiResponse.data.data.suppliers_billing_details[0].id !== null
              ? apiResponse.data.data.suppliers_billing_details[0].id
              : null;
          SetSupplierBillingId(supplierBillingId);
          const paymentTermsId =
            apiResponse.data.data.company_payment_terms[0].id !== null
              ? apiResponse.data.data.company_payment_terms[0].id
              : null;
          setPaymentTermsId(paymentTermsId);

          if (gstVendorId) {
            const matchingPayment =
              apiResponse.data.data.company_payment_terms.find(
                (payment) => payment.company === CompanyId
              );
            const selectedId = matchingPayment ? matchingPayment.id : null;
            setAddedVendorId(selectedId);
          } else {
            setAddedVendorId(
              apiResponse.data.data.company_payment_terms.length > 0
                ? apiResponse.data.data.company_payment_terms[0].id
                : null
            );
          }

          // Show popup message and redirect to login page
          // message.success({
          //   content: t("Vendor added successfully. Awaiting admin approval."),
          //   duration: 3,
          //   onClose: () => {
          //     navigate("/login");
          //   },
          // });

          setFormSubmitted(true);
          updateSubscriptionStatus();
          SuccessNotificationMsg(
            VendorId === null
              ? t("vendor_added_successfully")
              : t("vendor_updated_successfully")
          );
          setShowKeyPersonCollapse(true);
          setShowVendorCommunicationCollapse(true);
        }
        setBtnLoading(false);
      } catch (error) {
        setBtnLoading(false);
        setIsGstNoReadOnly(false);
      }
    } else {
      ErrorNotificationMsg("Already Existing Vendor");
    }
  };

  const handlePincodeBillingChange = async (
    registered_business_address_pincode
  ) => {
    if (
      registered_business_address_pincode.length > 4 &&
      registered_business_address_pincode !== null &&
      registered_business_address_pincode !== "" &&
      registered_business_address_pincode !== undefined
    ) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${registered_business_address_pincode}`
        );
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id, pincode_number } =
            response.data.results.data[0];
          setState((prevState) => ({
            ...prevState,
            registered_business_address_state: state_name,
            registered_business_address_city: city_name,
            registered_business_address_pincode: id,
            registered_business_address_pincode_number: pincode_number,
          }));
          formRef.current.setFieldsValue({
            registered_business_address_state: state_name,
            registered_business_address_city: city_name,
          });
        }
      } catch (error) {
        console.error("Error fetching state and city:", error);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        registered_business_address_state: "",
        registered_business_address_city: "",
        registered_business_address_pincode: "",
        registered_business_address_pincode_number: "",
      }));
      formRef.current.setFieldsValue({
        registered_business_address_state: "",
        registered_business_address_city: "",
      });
    }
  };

  const searchINShipping = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListShipping(apiResponse.data.results.data);
    }
  };

  const onSearchShipping = async (value) => {
    setSearchValueShipping(value);
    value.length >= 4
      ? searchINShipping(!value ? null : value)
      : setPincodeListShipping([]);
  };

  const setWeightSizeInquiryFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};

    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      const cityNames = objectValue.city.map((city) => city.name).join(", ");

      fieldObject["company_material_type" + objectKey] =
        objectValue.company_material_type
          .map((material) => material.name)
          .join(", ");
      fieldObject["minimum_inquiry_value" + objectKey] =
        objectValue.minimum_inquiry_value;
      fieldObject["maximum_inquiry_value" + objectKey] =
        objectValue.maximum_inquiry_value;
      fieldObject["city_name" + objectKey] = cityNames;

      return null;
    });

    formRef.current.setFieldsValue(fieldObject);
  };

  const setWeightSizeAssignCityValue = (data) => {
    let stateArr = [];
    let fieldObject = {};

    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["category_tree" + objectKey] = 1;
      fieldObject["material_type" + objectKey] = objectValue.material_type;
      fieldObject["state" + objectKey] = objectValue.state;
      fieldObject["city" + objectKey] = objectValue.city;
      fieldObject["gst_number" + objectKey] = objectValue.gst_number;
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  const setWeightSizeInquiryFieldValueCity = (data) => {
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return;
    }

    let stateArr = [];
    let fieldObject = {};

    data.forEach((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject[`category_tree${objectKey}`] = objectValue.category_tree;
      fieldObject[`material_type${objectKey}`] = objectValue.material_type;
      fieldObject[`city${objectKey}`] = objectValue.city_id;
    });
    if (formRef.current) {
      formRef.current.setFieldsValue(fieldObject);
    } else {
      console.error("formRef.current is not defined");
    }
  };
  const setWeightSizeInquiryFieldValueCommunicationMatrix = (data) => {
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return;
    }

    let stateArr = [];
    let fieldObject = {};

    data.forEach((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject[`category_tree${objectKey}`] = objectValue.category_tree;
      fieldObject[`material_type${objectKey}`] = objectValue.material_type;
      fieldObject[`vendor_matrix_steps${objectKey}`] = objectValue.id;
    });

    if (formRef.current) {
      formRef.current.setFieldsValue(fieldObject);
    } else {
      console.error("formRef.current is not defined");
    }
  };
  const setWeightSizeInquiryFieldValueSuppliers = (data) => {
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return;
    }

    let stateArr = [];
    let fieldObject = {};

    data.forEach((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject[`category_tree_${objectKey}`] = objectValue.category_tree;
      fieldObject[`gst_for_billing_${objectKey}`] = objectValue.gst_for_billing;
      fieldObject[`address_line_1_${objectKey}`] = objectValue.address_line_1;
      fieldObject[`address_line_2_${objectKey}`] = objectValue.address_line_2;
      fieldObject[`person_name_${objectKey}`] = objectValue.person_name;
      fieldObject[`landmark_${objectKey}`] = objectValue.landmark;
      fieldObject[`email_${objectKey}`] = objectValue.email;
      fieldObject[`mobile_number_${objectKey}`] = objectValue.mobile_number;
      fieldObject[`state_${objectKey}`] = objectValue.state;
      fieldObject[`city_${objectKey}`] = objectValue.city;
      fieldObject[`pincode_${objectKey}`] = objectValue.pincode;
    });

    if (formRef.current) {
      formRef.current.setFieldsValue(fieldObject);
    } else {
      console.error("formRef.current is not defined");
    }
  };

  const handleSameAsRegisteredBusinessAddressChange = (e) => {
    const checked = e.target.checked;
    setSameAsRegisteredBusinessAddress(checked);

    if (checked) {
      setState((prevState) => {
        return {
          ...prevState,
          same_as_registered_business_address: true,
          trading_address_building:
            prevState.registered_business_address_building,
          trading_address_area: prevState.registered_business_address_area,
          trading_address_landmark:
            prevState.registered_business_address_landmark,
          trading_address_state: prevState.registered_business_address_state,
          trading_address_city: prevState.registered_business_address_city,
          trading_address_pincode:
            prevState.registered_business_address_pincode,
          trading_address_pincode_number:
            prevState.registered_business_address_pincode_number,
        };
      });
      formRef.current.setFieldsValue({
        trading_address_building: state.registered_business_address_building,
        trading_address_area: state.registered_business_address_area,
        trading_address_landmark: state.registered_business_address_landmark,
        trading_address_state: state.registered_business_address_state,
        trading_address_city: state.registered_business_address_city,
        trading_address_pincode:
          state.registered_business_address_pincode_number,
      });

      if (
        state?.registered_business_address_state !== null &&
        state?.registered_business_address_state !== undefined &&
        state?.registered_business_address_state !== ""
      ) {
        ////getCityByStateTrading(state.registered_business_address_state);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        same_as_registered_business_address: false,
        trading_address_building: "",
        trading_address_area: "",
        trading_address_landmark: "",
        trading_address_state: "",
        trading_address_city: "",
        trading_address_pincode: "",
      }));

      formRef.current.setFieldsValue({
        trading_address_building: "",
        trading_address_area: "",
        trading_address_landmark: "",
        trading_address_state: "",
        trading_address_city: "",
        trading_address_pincode: "",
      });
    }
  };

  const colors = ["#094E8F"];
  return (
    <>
      <section className="vendor-Form-Page">
        <div className="vendorleft">
         
          <div className="wrapper" style={{gap:'16px'}}>
            <div>  <img
                className="NavLogo"
                src={newLogo}
                height={"40px"}
                alt="Smart Buyer Logo"
              ></img></div>
            <div style={{flex:'auto', display:'flex', alignItems:'center'}}>
             <div>
              <h3>Welcome to Procem</h3>
              <p>
              We are excited to have you onboard To get started, please enter your details below.
              </p>
              </div>
            </div>
          </div>
        </div>

        <div className="vendorright">
             <div
                    className="pagetitle"
                  
                  >
                    {VendorId !== null ? (
                      <span>Edit Vendor</span>
                    ) : (
                      <span>Register As Vendor</span>
                    )}
                  </div>
         
              <Form
                onFinish={handleSubmit}
                autoComplete="off"
                ref={formRef} className="stepscontentwrap"
              >
              
            
                  
                
         
                 
                  <div className="stepsContent">
                      <Spin spinning={apiLoading}>
                    <div
                      className="formwrapper"
                      style={{ paddingRight: "5px" }}
                    >
                      <div>
                        <Collapse defaultActiveKey={["1"]} onChange={onChange}>
                          <Panel header="Business Info" key="1">
  <Row gutter={16} style={{ marginBottom: 24 }}>
                          <Col
                            xs={24}
                            sm={24}
                            md={12}
                            xl={12}
                            xxl={12}
                            className="TextFeild gutter-row"
                          >
                            <div className="verifywrap">
                              <InputField
                                name="gst_no"
                                label={t("place_gst_no5")}
                                placeholder={t("place_gst_no")}
                                rules={t("val_gst_no")}
                                pattern={
                                  "^[0-9]{2}[A-Z]{5}[0-9]{4}" +
                                  "[A-Z]{1}[1-9A-Z]{1}" +
                                  "Z[0-9A-Z]{1}$"
                                }
                                prefix={<IdcardOutlined />}
                                handleInputChange={handleGstInputChange}
                              />
                              {verifyGstButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  label={t("Verify")}
                                  className="SaveGradiantBtn verify"
                                  loading={btnLoadingVerifyGst}
                                  onClick={handleGstNumberVerify}
                                  disabled={state?.gst_no ? false : true}
                                />
                              ) : (
                                ""
                              )}

                              {verificationStatus === "success" && (
                                <img
                                  src={verifybtn}
                                  style={{ height: "36px", marginTop: "29px" }}
                                ></img>
                              )}
                            </div>
                          </Col>
                          <Col
                            xs={24}
                            sm={24}
                            md={12}
                            xl={12}
                            xxl={12}
                            className="TextFeild gutter-row"
                          >
                            <div className="verifywrap">
                              <InputField
                                name="udyam_aadhaar_no"
                                label={t("Udyam Number")}
                                placeholder={t("Enter udyam number")}
                                prefix={<IdcardOutlined />}
                                handleInputChange={handleInputAdhaarChange}
                              />
                              {verifyAdhaarButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  className="SaveGradiantBtn verify"
                                  onClick={handleAdhaarNumberVerify}
                                  label={t("Verify")}
                                  loading={btnLoadingAdhaar}
                                  disabled={
                                    state?.udyam_aadhaar_no ? false : true
                                  }
                                />
                              ) : (
                                ""
                              )}

                              {verificationResultAdhaar === "success" && (
                                <img
                                  src={verifybtn}
                                  style={{ height: "36px", marginTop: "29px" }}
                                ></img>
                              )}
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={12} xl={8} xxl={8}>
                            <div className="verifywrap">
                              <InputField
                                name="vendor_registered_name"
                                label={t("label_vendor_company_name")}
                                placeholder={t("pl_vendor_company_name")}
                                rules={t("val_vendor_company_name")}
                                prefix={<Vector />}
                                handleInputChange={handleInputChange}
                                max={40}
                              />
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={12} xl={8} xxl={8}>
                            <div className="verifywrap">
                              <InputField
                                placeholder="Enter vendor trade name"
                                name="vendor_trade_name"
                                max={40}
                                label={
                                  <Tooltip
                                    color={colors}
                                    placement="right"
                                    title={t(
                                      "Please enter a valid vendor trade name"
                                    )}
                                  >
                                    <span>{t("Vendor Trade Name")}</span>
                                  </Tooltip>
                                }
                                rules={t("Please enter vendor trade name")}
                                prefix={<AddressLine />}
                                handleInputChange={handleInputChange}
                              />
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={12} xl={8} xxl={8}>
                            <div className="verifywrap">
                              <InputField
                                name="vendor_code_by_company"
                                label={t(
                                  "Vendor Code (Company ERP System)"
                                )}
                                placeholder={t("pl_enter_vendor_code")}
                                handleInputChange={handleInputChangeVendorCode}
                                prefix={<FileAlt />}
                                // rules={t("Please enter vendor code")}
                              />
                            </div>
                          </Col>
                        </Row>
                          </Panel>
                          <Panel header="Contact Information" key="2">
  <Row gutter={16} style={{ marginBottom: 24 }}>
                          <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                            <InputField
                              name="person_name"
                              label={t("label_person_name")}
                              placeholder={t("pl_person_name")}
                              rules={t("val_person_name")}
                              prefix={<Name />}
                              handleInputChange={handleInputChange}
                              max={30}
                              pattern="^[A-Za-z\s]+$"
                            />
                          </Col>
                          <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                            <InputField
                              name="designation"
                              label={t("label_designation")}
                              placeholder={t("pl_designation")}
                              rules={t("val_designation")}
                              prefix={<AddressLine />}
                              handleInputChange={handleInputChange}
                              max={30}
                              pattern="^[A-Za-z\s]+$"
                            />
                          </Col>
                          <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                            <div className="verifywrap">
                              <EmailField
                                name="email"
                                label={t("label_email")}
                                placeholder={t("pl_email_2")}
                                rules={t("val_email")}
                                prefix={<Email />}
                                handleInputChange={handleInputChangeEmail}
                              />

                              {verifyEmailButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  className="SaveGradiantBtn verify"
                                  onClick={handleEmailVerify}
                                  label={t("Verify")}
                                  loading={btnLoadingEmail}
                                  disabled={state?.email ? false : true}
                                />
                              ) : (
                                ""
                              )}

                              {verificationResultEmail === "success" && (
                                <img
                                  src={verifybtn}
                                  style={{ height: "36px", marginTop: "29px" }}
                                ></img>
                              )}
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                            <div className="verifywrap">
                              <Form.Item
                                name="phone"
                                label={t("label_mobileNumber")}
                                placeholder={t("pl_mobileNumber")}
                                rules={[
                                  {
                                    required: true,
                                    validator: validatePhoneNumber,
                                    message: (
                                      <Trans> {t("val_mobileNumber")}</Trans>
                                    ),
                                  },
                                ]}
                              >
                                <div className="verifywrap">
                                  <div className="phonefield">
                                    <PhoneInput
                                      className="PhoneSection"
                                      country={"in"}
                                      value={state.phone}
                                      onChange={handlePhoneInputChange}
                                    />
                                  </div>
                                </div>
                              </Form.Item>
                              {verifyPhoneButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  className="SaveGradiantBtn verify"
                                  onClick={handleContactNumberVerify}
                                  label={t("Verify")}
                                  loading={btnLoadingPhone}
                                  disabled={state?.phone ? false : true}
                                />
                              ) : (
                                ""
                              )}

                              {verificationResultContact === "success" && (
                                <img
                                  src={verifybtn}
                                  style={{ height: "36px", marginTop: "29px" }}
                                ></img>
                              )}
                            </div>
                          </Col>
                        </Row>
                          </Panel>
                          <Panel header="Registered Business Address" key="3">
 <Row gutter={16}>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_building"
                                  label={<span>{t("Shop No., Building")}</span>}
                                  rules={[
                                    {
                                      required: true,
                                      message: t(
                                        "Please enter shop no., building, company"
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("Enter shop no., building")}
                                    maxLength={50}
                                    value={
                                      state.registered_business_address_building
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "registered_business_address_building",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_area"
                                  label={<span>{t("Area, Street")}</span>}
                                  rules={[
                                    {
                                      required: true,
                                      message: t("Please enter Area, Street"),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("Enter area, street")}
                                    maxLength={50}
                                    value={
                                      state.registered_business_address_area
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "registered_business_address_area",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_landmark"
                                  label={<span>{t("Landmark")}</span>}
                                  rules={[
                                    {
                                      required: true,
                                      message: t("Please enter landmark"),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("Enter landmark")}
                                    maxLength={50}
                                    value={
                                      state.registered_business_address_landmark
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "registered_business_address_landmark",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>

                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_pincode"
                                  label={<span>{t("pl_pincode")}</span>}
                                  prefix={<ZipCode />}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>
                                          {t("val_postal_zip_code")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  {/* <AutoComplete
                                                     className="autoComplete"
                                                     onSelect={onSelectShipping}
                                                     onSearch={onSearchShipping}
                                                     value={searchValueBilling}
                                                     optionFilterProp="children"
                                                     placeholder={t("pl_pincodeselect")}
                                                     onChange={(value) =>
                                                       handlePincodeBillingChange(
                                                         "registered_business_address_pincode",
                                                         value
                                                       )
                                                     }
                                                   >
                                                     {pincodeListShipping.map((option) => (
                                                       <Option
                                                         key={option.id}
                                                         value={option.pincode_number}
                                                       >
                                                         {option.pincode_number}
                                                       </Option>
                                                     ))}
                                                   </AutoComplete> */}

                                  <AutoComplete
                                    className="autoComplete"
                                    //onSelect={onSelectBilling}
                                    onSearch={onSearchBillingResgistered}
                                    value={
                                      state.registered_business_address_pincode
                                    }
                                    optionFilterProp="children"
                                    allowClear
                                    placeholder={t("pl_pincodeselect")}
                                    onChange={handlePincodeBillingChange}
                                    onKeyPress={(e) => {
                                      if (!/^\d$/.test(e.key)) {
                                        e.preventDefault(); // blocks any non-numeric key
                                      }
                                    }}
                                  >
                                    {pincodeListBillingRegistered &&
                                      pincodeListBillingRegistered.map(
                                        (option) => (
                                          <Option
                                            key={option.id}
                                            value={option.pincode_number}
                                          >
                                            {option.pincode_number}
                                          </Option>
                                        )
                                      )}
                                  </AutoComplete>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_city"
                                  label={<span>{t("pl_city")}</span>}
                                  rules={[
                                    {
                                      required: true,
                                      message: <Trans>{t("val_city")}</Trans>,
                                    },
                                  ]}
                                >
                                  {/* <Select
                                                   showArrow
                                                   showSearch
                                                   optionFilterProp="children"
                                                   placeholder={t("place_city")}
                                                   // onChange={(value) => handleRoleSelectChange(value)}
                                                   onChange={(value) => handleCityChange(value)}
                                                   //onChange={handleCityChange}
                                                   prefix={<ZipCode />}
                                                 >
                                                   {cityDropdownOptionsShipping.map((item) => (
                                                     <Select.Option key={item.id} value={item.id}>
                                                       {item.name}
                                                     </Select.Option>
                                                   ))}
                                                 </Select> */}
                                  <Input
                                    placeholder={t("place_city")}
                                    value={
                                      state.registered_business_address_city
                                    }
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_state"
                                  label={<span>{t("pl_state_province")}</span>}
                                  value={
                                    state.registered_business_address_state
                                  }
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>{t("val_state_province")}</Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  {/* <Select
                                                     showArrow
                                                     showSearch
                                                     placeholder={t("place_state")}
                                                     onChange={(value) =>
                                                       handleStateChangeRegistered(value)
                                                     }
                                                     optionFilterProp="children"
                                                     // onChange={handleStateChangeShipping}
                                                     prefix={<ZipCode />}
                                                   >
                                                     {stateDropdownOptionsShipping.map((item) => (
                                                       <Option key={item.id} value={item.id}>
                                                         {item.name}
                                                       </Option>
                                                     ))}
                                                   </Select> */}
                                  <Input
                                    value={
                                      state.registered_business_address_state
                                    }
                                    placeholder={t("place_state")}
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </Panel>
                          <Panel header="Trading Address" key="4">
 <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                fontWeight: 600,
                                fontSize: 17,
                                marginBottom: 8,
                                color: "#333",
                                borderBottom: "1px solid #eee",
                                paddingBottom: 4,
                              }}
                            >
                              <div></div>

                              <Tooltip
                                title="Same as registered business address"
                                name="same_as_registered_business_address"
                              >
                                <Checkbox
                                  checked={sameAsRegisteredBusinessAddress}
                                  onChange={(e) =>
                                    handleSameAsRegisteredBusinessAddressChange(
                                      e
                                    )
                                  }
                                >
                                  Same as my business address
                                </Checkbox>
                              </Tooltip>
                            </div>

                            <Row gutter={16}>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_building"
                                  label={t("Shop No., Building")}
                                  rules={[
                                    {
                                      required: true,
                                      message: t(
                                        "Please enter shop no., building"
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("Enter shop no., building")}
                                    maxLength={50}
                                    value={state.trading_address_building}
                                    onChange={(e) =>
                                      handleChange(
                                        "trading_address_building",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_area"
                                  label={t("Area, Street")}
                                  rules={[
                                    {
                                      required: true,
                                      message: t("Please enter Area, Street"),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("Enter area, street")}
                                    maxLength={50}
                                    value={state.trading_address_area}
                                    onChange={(e) =>
                                      handleChange(
                                        "trading_address_area",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_landmark"
                                  label={t("Landmark")}
                                  rules={[
                                    {
                                      required: true,
                                      message: t("Please enter landmark"),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("Enter landmark")}
                                    maxLength={50}
                                    value={state.trading_address_landmark}
                                    onChange={(e) =>
                                      handleChange(
                                        "trading_address_landmark",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_pincode"
                                  label={<span>{t("pl_pincode")}</span>}
                                  prefix={<ZipCode />}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>
                                          {t("val_postal_zip_code")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  {/* <AutoComplete
                                                     className="autoComplete"
                                                     onSelect={onSelectBilling}
                                                     onSearch={onSearchBilling}
                                                     value={searchValueBilling}
                                                     optionFilterProp="children"
                                                     allowClear
                                                     placeholder={t("pl_pincodeselect")}
                                                     onChange={(value) =>
                                                       handlePincodeBillingChange(
                                                         "trading_address_pincode",
                                                         value
                                                       )
                                                     }
                                                   >
                                                     {pincodeListBillingTranding.map((option) => (
                                                       <Option
                                                         key={option.id}
                                                         value={option.pincode_number}
                                                       >
                                                         {option.pincode_number}
                                                       </Option>
                                                     ))}
                                                   </AutoComplete> */}
                                  <AutoComplete
                                    className="autoComplete"
                                    // onSelect={onSelectShipping}
                                    onSearch={onSearchShippingTrading}
                                    value={state.trading_address_pincode}
                                    optionFilterProp="children"
                                    allowClear
                                    placeholder={t("pl_pincodeselect")}
                                    onChange={
                                      handlePincodeShippingTradingChange
                                    }
                                    onKeyPress={(e) => {
                                      if (!/^\d$/.test(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                  >
                                    {pincodeListShippingtrading.map(
                                      (option) => (
                                        <Option
                                          key={option.id}
                                          value={option.pincode_number}
                                        >
                                          {option.pincode_number}
                                        </Option>
                                      )
                                    )}
                                  </AutoComplete>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_city"
                                  label={<span>{t("pl_city")}</span>}
                                  rules={[
                                    {
                                      required: true,
                                      message: <Trans>{t("val_city")}</Trans>,
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("place_city")}
                                    value={state.trading_address_city}
                                    disabled
                                  />
                                  {/* <Select
                                                     showArrow
                                                     showSearch
                                                     optionFilterProp="children"
                                                     placeholder={t("place_city")}
                                                     // onChange={(value) => handleRoleSelectChange(value)}
                                                     // onChange={(value) =>
                                                     //   handleChange("billing_city", value)
                                                     // }
                                                     onChange={handleTradingCityChange}
                                                     prefix={<ZipCode />}
                                                   >
                                                     {tradingCityDropdownOptions.map((item) => (
                                                       <Select.Option key={item.id} value={item.id}>
                                                         {item.name}
                                                       </Select.Option>
                                                     ))}
                                                   </Select> */}
                                </Form.Item>
                              </Col>

                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_state"
                                  label={<span>{t("pl_state_province")}</span>}
                                  value={state.trading_address_state}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>{t("val_state_province")}</Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("place_state")}
                                    value={state.trading_address_state}
                                    disabled
                                  />
                                  {/* <Select
                                                     showArrow
                                                     showSearch
                                                     optionFilterProp="children"
                                                     placeholder={t("place_state")}
                                                     // onChange={(value) =>
                                                     //   handleChange("shipping_state", value)
                                                     // }
                                                     onChange={handleStateChangeTrading}
                                                     prefix={<ZipCode />}
                                                   >
                                                     {stateDropdownOptionsShipping.map((item) => (
                                                       <Option key={item.id} value={item.id}>
                                                         {item.name}
                                                       </Option>
                                                     ))}
                                                   </Select> */}
                                </Form.Item>
                              </Col>
                            </Row>
                          </Panel>
                        </Collapse>
                 
              
                      
                      
                        {/* Buttons Row */}
                       
                      </div>
                    </div>
                    </Spin>
                  </div>
           <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 16,
                            padding:'16px'
                          }}
                        >
                          <Button
                            cursor="pointer"
                            type="secondary"
                            className="CancelGradiantBtn"
                            onClick={() => navigate("/login")}
                          >
                            Login
                          </Button>
                          <Button
                            cursor="pointer"
                            loading={btnLoading}
                            className="SaveGradiantBtn SendBtn"
                            icon={<FileDoneOutlined />}
                            type="primary"
                            htmlType="submit"
                            label="Save"
                          >
                            Register Vendor
                          </Button>
                        </div>
              </Form>
     
        </div>
      </section>

    
    </>
  );
};

export default Vendorlogin;
